'use strict';

var hgInformation = {
    name:'HireGround Software',
    phone:'403-244-1895 x221',
    tollfree: '1-877-218-7504 x221',
    email: 'support@hiregroundsoftware.com'
};

module.exports = hgInformation;